import { WSFilter } from "@wingspanhq/fe-component-library";
import { BatchStatus } from "@wingspanhq/wingspan-api-sdk";

import { STATUS_FILTER_ALL } from "./types";

export function buildImportBatchFiltersConfig(): WSFilter[] {
  return [
    {
      title: "Import status",
      name: "status",
      type: "radio",
      options: [
        { name: STATUS_FILTER_ALL, label: "All", hidePill: true },
        { name: BatchStatus.CREATED, label: "Awaiting import" },
        { name: BatchStatus.PENDING, label: "Import queued" },
        { name: BatchStatus.PROCESSING, label: "Importing" },
        { name: BatchStatus.COMPLETED, label: "Complete" },
        { name: BatchStatus.FAILED, label: "Failed" }
      ]
    }
  ];
}
